/**
 * 세그먼트 — 값 하나 고르기.
 *
 * C2 의 영역·PLAN, C4 의 영역·상태·중요도·PLAN, C1-4 시트의 조건
 * 줄이 모두 이 생김새입니다. 같은 일에 같은 모양을 써서 한 번 익히면 통합니다.
 *
 * **다시 눌러도 그대로입니다.** 정렬은 다시 누르면 방향이 뒤집혀야 하는데,
 * 방향이 있는 값과 없는 값을 한 부품에 담으면 상태를 다시 눌렀을 때 뒤집히는
 * 사고가 납니다. 그래서 정렬 칩은 FilterBar 가 따로 그립니다.
 */

interface Option<T extends string> {
  value: T;
  label: string;
}

interface SegProps<T extends string> {
  label: string;
  options: Option<T>[];
  value: T;
  onChange: (value: T) => void;
  /** 켜졌을 때만 빨강으로 칠할 값 — 중요도 '긴급' */
  crit?: T;
}

export function Seg<T extends string>({ label, options, value, onChange, crit }: SegProps<T>) {
  return (
    <div className="seg" role="group" aria-label={label}>
      {options.map((o) => {
        const on = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            className={on ? (o.value === crit ? 'sg sg--crit' : 'sg sg--on') : 'sg'}
            aria-pressed={on}
            onClick={() => onChange(o.value)}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
